/**
 * MC Sélection produits — défilement du rail mobile à la souris.
 *
 * Sur téléphone, le rail défile tout seul : c'est un conteneur
 * `overflow-x: auto`, le doigt suffit. Mais dès qu'on regarde la page dans une
 * fenêtre d'ordinateur rétrécie à la largeur mobile — ce que fait n'importe qui
 * pour relire le site — il n'y a plus ni doigt ni barre de défilement (elle est
 * masquée pour le rendu), et la molette verticale fait défiler la page, pas le
 * rail : la section a l'air figée.
 *
 * Ce module ajoute donc le glisser-déposer à la souris, sans toucher au
 * comportement tactile (on ignore volontairement `pointerType === 'touch'`,
 * pour laisser faire le défilement natif, plus fluide et inertiel).
 *
 * Les cartes étant des liens, on neutralise le clic qui suit un vrai
 * glissement : sans ça, relâcher la souris ouvrirait la fiche produit.
 */
(function () {
	'use strict';

	var RAIL = '.mc-featured-mobile-rail';
	var THRESHOLD = 6; /* px avant de considérer que c'est un glissement */

	function setup(rail) {
		if (rail.dataset.mcRailDrag === '1') return;
		rail.dataset.mcRailDrag = '1';

		var pointerId = null;
		var startX = 0;
		var startScroll = 0;
		var moved = 0;

		function swallowClick(event) {
			event.preventDefault();
			event.stopPropagation();
		}

		rail.addEventListener('pointerdown', function (event) {
			if (event.pointerType === 'touch') return;
			if (event.button !== 0) return;
			if (rail.scrollWidth <= rail.clientWidth) return;

			pointerId = event.pointerId;
			startX = event.clientX;
			startScroll = rail.scrollLeft;
			moved = 0;
		});

		rail.addEventListener('pointermove', function (event) {
			if (pointerId === null || event.pointerId !== pointerId) return;

			var dx = event.clientX - startX;
			if (Math.abs(dx) > moved) moved = Math.abs(dx);
			if (moved <= THRESHOLD) return;

			if (!rail.hasPointerCapture(pointerId)) {
				rail.setPointerCapture(pointerId);
				rail.classList.add('mc-rail-grabbing');
			}

			event.preventDefault();
			rail.scrollLeft = startScroll - dx;
		});

		function release() {
			if (pointerId === null) return;

			if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
			rail.classList.remove('mc-rail-grabbing');
			pointerId = null;

			/* Le clic arrive juste après le relâchement : on l'avale une seule
			   fois, et seulement si l'utilisateur a réellement fait glisser. */
			if (moved > THRESHOLD) {
				rail.addEventListener('click', swallowClick, true);
				window.setTimeout(function () {
					rail.removeEventListener('click', swallowClick, true);
				}, 0);
			}
		}

		rail.addEventListener('pointerup', release);
		rail.addEventListener('pointercancel', release);

		/* Les images sont déplaçables par défaut : ça parasiterait le glissement. */
		rail.addEventListener('dragstart', function (event) {
			if (pointerId !== null) event.preventDefault();
		});
	}

	function init() {
		var rails = document.querySelectorAll(RAIL);
		for (var i = 0; i < rails.length; i++) setup(rails[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', init);
})();

/**
 * MC Selection produits — quick shop dans le rail mobile.
 *
 * Le pop-in de choix de taille du quick shop et son voile sont en
 * `position: fixed` : ils doivent se caler sur la fenetre, pas sur la carte.
 * Partout ailleurs sur le site les cartes sont dans une grille, donc ca marche.
 * Dans le rail mobile elles sont dans un conteneur `overflow-x: auto`, et Safari
 * iOS ROGNE les descendants fixes d un conteneur defilable sur la boite de ce
 * conteneur : le pop-in et le voile n apparaissaient plus que dans la bande du
 * rail. (Chrome, lui, respecte la specification : le bug ne se reproduit pas sur
 * ordinateur, d ou la necessite de raisonner et pas seulement de tester ici.)
 *
 * Correctif : le temps que le quick shop est ouvert, le rail n est plus un
 * conteneur defilable — donc plus rien a rogner. Pour que rien ne bouge a
 * l ecran, le decalage perdu (scrollLeft retombe a 0 avec overflow: visible) est
 * rendu par `position: relative` + `left`.
 *
 * Pourquoi `left` et pas `transform` ni une marge negative : un `transform`
 * ferait du rail le bloc englobant des elements fixes, ce qui recasserait tout
 * (c est exactement le piege qu on cherche a eviter) ; une marge negative
 * elargirait la boite du rail, et les cartes etant dimensionnees en pourcentage
 * (65%) elles changeraient de taille. `left` ne touche ni au bloc englobant ni
 * a la mise en page.
 *
 * On ecoute la classe `mm-pc-active` plutot que le clic : elle est posee et
 * retiree par le quick shop du theme (mmOpen/mmCloseProductCardMobileModal),
 * donc le rail est remis en etat quel que soit le chemin de fermeture — croix,
 * voile, ajout au panier.
 */
(function () {
	'use strict';

	var RAIL = '.mc-featured-mobile-rail';
	var ACTIVE = '.mm-product-card.mm-pc-active';

	function watch(rail) {
		if (rail.dataset.mcRailQuickShop === '1') return;
		rail.dataset.mcRailQuickShop = '1';

		var savedScroll = null;

		function release() {
			if (savedScroll !== null) return;
			savedScroll = rail.scrollLeft;
			rail.style.overflow = 'visible';
			rail.style.position = 'relative';
			rail.style.left = -savedScroll + 'px';
		}

		function restore() {
			if (savedScroll === null) return;
			rail.style.overflow = '';
			rail.style.position = '';
			rail.style.left = '';
			/* Lecture forcee : le rail doit etre redevenu defilable avant qu on
			   lui rende sa position, sinon l affectation est perdue. */
			void rail.offsetWidth;
			rail.scrollLeft = savedScroll;
			savedScroll = null;
		}

		function sync() {
			if (rail.querySelector(ACTIVE)) release();
			else restore();
		}

		new MutationObserver(sync).observe(rail, {
			subtree: true,
			attributes: true,
			attributeFilter: ['class']
		});

		sync();
	}

	function init() {
		var rails = document.querySelectorAll(RAIL);
		for (var i = 0; i < rails.length; i++) watch(rails[i]);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', init);
})();
